import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button} from 'antd'
import {withTranslation} from 'react-i18next'
import history from '../../../routes/history'
import FormModal from '../../marketingShortLink/components/FormModal'

@inject('marketingSmsManagementStore', 'marketingShortLinkStore', 'accountStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
  }
  componentDidMount() {
  }
  handlePageChange = (page, pageSize) => {
    const {marketingShortLinkStore} = this.props
    marketingShortLinkStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  handleInset = (record) => {
    const {marketingSmsManagementStore, onChangeInsertShortLink, handleCancel, t} = this.props
    marketingSmsManagementStore.onChangeShortLinkObj(record)
    onChangeInsertShortLink(record?.shortLink)
    handleCancel()
  }
  createShortLink = () => {
    const {accountStore} = this.props
    history.push(`/shortLink`)
    accountStore.setSeletedItem('shortLink')
    accountStore.onMenuClick(['shortLink'])
  }

  handleCancelShortLink=()=>{
    this.setState({
      addModalVisible: false
    })
  }
  render() {
    const {marketingShortLinkStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList} = marketingShortLinkStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <div style={{display: "flex", flexDirection:'row-reverse', marginBottom: 10}}><Button type='primary' onClick={()=>this.setState({addModalVisible: true})}>创建</Button></div>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} style={{marginTop: 0, padding: 0}}>
          <Table.Column title={t(`marketingManagement.oldLink`)} dataIndex="sourceLinkUrl" key="sourceLinkUrl" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.shortUrl`)} dataIndex="shortLink" key="shortLink" ellipsis={true}/>
          <Table.Column width={150} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleInset(record)}title={t(`general.inset`)}>{t(`general.inset`)}</Button>
            </>
          )}/>
        </Table>
        {/*{toJS(jobList).length>0 ? null : <div style={{textAlign: 'center', marginTop: 10}}>*/}
        {/*  前往创建<Button type='link' onClick={this.createShortLink}>{t(`marketingManagement.shortLink`)}</Button>*/}
        {/*</div>}*/}

        {/*创建短链弹窗*/}
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancelShortLink}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
